module.exports = __webpack_public_path__ + "png/2.png?1952f99103ccb184a4c499be9f672355";